import Utilities from '@util/Utilities';
import Tag from '@app/component/tag/Tag';
import React from 'react';
import CalendarDay from '@app/state/calendar/CalendarDay';
import {
	useMarketStateTools,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useMarketStateTools';
import Competitor from '@app/model/company_hotel/Competitor';
import {
	DisplayMarketStateSnapshotTableHotelPriceFragment
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/_table/fragment/DisplayMarketStateSnapshotTableHotelPriceFragment';

const MarketStateSnapshotHotelBasedTableRowFragment: React.FunctionComponent<{
	calendarDay: CalendarDay,
	competitor?: Competitor
}> = ({ calendarDay, competitor }) => {

	const tools = useMarketStateTools();

	const dailySnapshotState = tools.findDailySnapshotState(calendarDay.display);


	if (!!dailySnapshotState) {
		return <td
			className={Utilities.classNames('whitespace-nowrap px-3 py-4 text-sm text-gray-900 text-center relative', !competitor ? 'font-bold' : '', calendarDay.isPast ? 'opacity-30 bg-gray-200/60' : '')}>
			<DisplayMarketStateSnapshotTableHotelPriceFragment
				marketStateDailySnapshotState={dailySnapshotState}
				competitor={competitor} />
		</td>;
	}

	return <td className="text-center"><Tag state="none">Not Available</Tag></td>;
};

export default MarketStateSnapshotHotelBasedTableRowFragment;